module.exports = __webpack_public_path__ + "img/cart-01 1.6b30e5b6.png";